module.exports = __webpack_public_path__ + "static/img/1.8f5836b.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/about/news/chanpin/20200731/1.png
// module id = X4Ce
// module chunks = 1